import { WorkAreaService } from '@/app/services/work-areas'
import { ErrorResponse, PaginatedQueryResponse } from '@/types/api'
import { IWorkArea } from '@/types/work-area'
import { useQuery, UseQueryOptions } from 'react-query'

export function useWorkAreas(
  options?: Omit<
    UseQueryOptions<PaginatedQueryResponse<IWorkArea>, ErrorResponse>,
    'queryKey' | 'queryFn'
  >
) {
  return useQuery<PaginatedQueryResponse<IWorkArea>, ErrorResponse>(
    [WorkAreaService.GET_PATH],
    () => WorkAreaService.getWorkAreas(),
    options
  )
}
